import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiResponse, CartResponse } from '../models/api-response.model';
import { AccountDeliveryAddressPronto, AccountDeliveryAddress, SuburbList, CartBillingAndShippings, PostcodeList } from '../models/account-delivery-address';
// tslint:disable-next-line:import-blacklist
import { BehaviorSubject, Subject } from 'rxjs';
import { ShippingAddressViewModel } from '../models/shopping-cart.model';
import { FreightViewModel, DickerTransportZonesDetail, DickerSelectListItem, CheckoutViewModel, EndUserModel, TenantViewModel, GetCSPTenant, TenantResponse, CreateCSPOrder, PaymentApiResponse, CheckoutSummaryViewModel, OrderConfirmationViewModel, CheckoutStatusModel, ShippingAddress, GetEndUserSalesTypeOut, GetEndUserAddressBookOutput, PaymentViewModel, SHAusPostGetFreightQuoteResponse, CirrusTenantResponse } from '../models/check-out.model';
import { CustomerPaymentsOutput, PaywayCustomerRequest } from '../models/account-ledger.model';
import { HttpService } from './http.service';
import { AuthService } from './auth.service';
import { CartItem } from '../models/cart-item.model';
import { IGenericCustomer } from '../models/customer.model';

@Injectable()
export class CheckOutService {

  baseUrl = 'api/checkout';

  saveAddressStatus: boolean = false;
  shippingAddressModel: ShippingAddressViewModel = {} as ShippingAddressViewModel;
  redirectToDW = '';
  editAddressModel: AccountDeliveryAddress = {} as AccountDeliveryAddress;
  selectLocationModel: AccountDeliveryAddress = {} as AccountDeliveryAddress;
  selectEndUserModel: GetEndUserAddressBookOutput = {} as GetEndUserAddressBookOutput;
  getEndUserAddressBookOutput: GetEndUserAddressBookOutput = {} as GetEndUserAddressBookOutput;

  public dropdownAddress: EventEmitter<AccountDeliveryAddress> = new EventEmitter();

  private selectLocation = new BehaviorSubject<AccountDeliveryAddress>(this.selectLocationModel);
  selectLocationWatch = this.selectLocation.asObservable();

  private selectEndUser = new BehaviorSubject<GetEndUserAddressBookOutput>(this.selectEndUserModel);
  selectEndUserWatch = this.selectEndUser.asObservable();

  private getEndUserAddressBook = new BehaviorSubject<GetEndUserAddressBookOutput>(this.getEndUserAddressBookOutput);
  getEndUserAddressBookWatch = this.getEndUserAddressBook.asObservable();

  private saveAddress = new BehaviorSubject<boolean>(this.saveAddressStatus);
  saveAddressWatch = this.saveAddress.asObservable();

  private passModel = new BehaviorSubject<ShippingAddressViewModel>(this.shippingAddressModel);
  passModelWatch = this.passModel.asObservable();

  private addNewPayment = new BehaviorSubject<string>(this.redirectToDW);
  addNewPaymentWatch = this.addNewPayment.asObservable();

  private editAddress = new BehaviorSubject<AccountDeliveryAddress>(this.editAddressModel);
  editAddressWatch = this.editAddress.asObservable();

  private showXscroll = new BehaviorSubject<boolean>(false);
  editShowXscroll = this.showXscroll.asObservable();

  private checkoutViewModel = new BehaviorSubject<CheckoutViewModel>(null);
  currentCheckoutViewModel = this.checkoutViewModel.asObservable();

  private checkouStatusModel = new BehaviorSubject<CheckoutStatusModel>(null);
  currentCheckoutStatusModel = this.checkouStatusModel.asObservable();

  private isShowCartSummary = new Subject<string>();
  currentIsShowCartSummary = this.isShowCartSummary.asObservable();

  public skipEndUserStep$ = new BehaviorSubject<boolean>(false);

  public selectedDigitalWallet$ = new BehaviorSubject<DickerSelectListItem>(null);

  public deliveryAddressBook$: Subject<void> = new Subject<void>();

  constructor(private http: HttpClient,
    private httpService: HttpService,
    private authService: AuthService
  ) { }

  monitorShowCartSummary(value: string) {
    this.isShowCartSummary.next(value);
  }

  monitorCurrerntCheckoutStatusModel(model: CheckoutStatusModel) {
    this.checkouStatusModel.next(model);
  }

  monitorCurrentCheckoutViewModel(checkoutViewModel: CheckoutViewModel) {
    this.checkoutViewModel.next(checkoutViewModel);
  }

  monitorGetEndUserAddressBook(getEndUserAddressBook: GetEndUserAddressBookOutput): void {
    this.getEndUserAddressBook.next(getEndUserAddressBook);
  }

  monitorXscroll(show: boolean): void {
    this.showXscroll.next(show);
  }

  monitorEditAddress(addressDelivery: AccountDeliveryAddress): void {
    this.editAddress.next(addressDelivery);
  }

  monitorPassModel(shippingAddressModel: ShippingAddressViewModel): void {
    this.passModel.next(shippingAddressModel);
  }

  monitorSaveAddress(message: boolean): void {
    this.saveAddress.next(message);
  }

  monitorRedirectToDW(message: string): void {
    this.addNewPayment.next(message);
  }

  monitorSelectLocation(value: AccountDeliveryAddress): void {
    this.selectLocation.next(value);
  }

  monitorSelectEndUser(value: GetEndUserAddressBookOutput): void {
    this.selectEndUser.next(value);
  }

  dropdownEvent(value: AccountDeliveryAddress) {
    this.dropdownAddress.emit(value);
  }

  setShippingAddress(val: ShippingAddressViewModel): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl + '/SetShippingAddress', val)
      .pipe(catchError(this.authService.handleError));
  }

  setAccountAddress(val: AccountDeliveryAddress): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl + '/SetAccountAddress', val)
      .pipe(catchError(this.authService.handleError));
  }

  GetCartBillingNShipping(cartId: string): Observable<CartBillingAndShippings> {
    return this.http.get<CartBillingAndShippings>(this.baseUrl + '/GetCartBillingNShipping?cartId=' + cartId)
      .pipe(catchError(this.authService.handleError));
  }

  getDeliveryAddressBook(): Observable<AccountDeliveryAddressPronto[]> {
    return this.http.get<AccountDeliveryAddressPronto[]>(this.baseUrl + '/GetDeliveryAddressBook')
      .pipe(catchError(this.authService.handleError));
  }

  /* getPostCodeList(postcode: string): Observable<SuburbList[]> {
    return this.http.get<SuburbList[]>(this.baseUrl + '/GetPostCodeList?postcode=' + postcode)
      .pipe(catchError(this.authService.handleError));
  } */

  getPostCodeFromAPI(suburbSearchKey: string, postcode: string): Observable<PostcodeList[]> {   
    return this.http.get<PostcodeList[]>(`${this.baseUrl}/GetPostCodeList?suburbSearchKey=${suburbSearchKey}&postcode=${postcode}`)    
    .pipe(catchError(err => {
      this.authService.handleError;
      throw err;
    }));
}

  GetFreight(cartId: string): Observable<FreightViewModel> {
    return this.http.get<FreightViewModel>(this.baseUrl + '/GetFreight?cartId=' + cartId)
      .pipe(catchError(this.authService.handleError));
  }

  GetPayment(cartId: string): Observable<PaymentViewModel> {
    return this.http.get<PaymentViewModel>(this.baseUrl + '/GetPayment?cartId=' + cartId)
      .pipe(catchError(this.authService.handleError));
  }

  GetZoneInfo(zoneID: number): Observable<DickerTransportZonesDetail[]> {
    return this.http.get<DickerTransportZonesDetail[]>(this.baseUrl + '/GetZoneInfo?zoneID=' + zoneID)
      .pipe(catchError(this.authService.handleError));
  }

  UpdateFreight(cartId: string, billing: any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl + '/UpdateFreight?cartId=' + cartId, billing)
      .pipe(catchError(this.authService.handleError));
  }

  GetPaymentMethodList(): Observable<CustomerPaymentsOutput[]> {
    return this.http.get<CustomerPaymentsOutput[]>(this.baseUrl + '/GetPaymentMethodList')
      .pipe(catchError(this.authService.handleError));
  }

  GetSubscriptionPaymentMethodList(): Observable<CustomerPaymentsOutput[]> {
    return this.http.get<CustomerPaymentsOutput[]>(this.baseUrl + '/GetSubscriptionPaymentMethodList')
      .pipe(catchError(this.authService.handleError));
  }

  GetSubscriptionDigitalWallet(loginId = ""): Observable<DickerSelectListItem[]> {
    return this.http.get<DickerSelectListItem[]>(this.baseUrl + '/GetSubscriptionDigitalWallet?loginId=' + loginId)
      .pipe(catchError(this.authService.handleError));
  }

  GetDigitalWallet(): Observable<DickerSelectListItem[]> {
    return this.http.get<DickerSelectListItem[]>(this.baseUrl + '/GetDigitalWallet')
      .pipe(catchError(this.authService.handleError));
  }
  DeletePaywayCustomer(customerNumber: string): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(this.baseUrl + '/DeletePaywayCustomer?customerNumber=' + customerNumber)
      .pipe(catchError(this.authService.handleError));
  }

  EnablePaywayCustomer(customerNumber: string): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(this.baseUrl + '/EnablePaywayCustomer?customerNumber=' + customerNumber)
      .pipe(catchError(this.authService.handleError));
  }

  DisablePaywayCustomer(customerNumber: string): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(this.baseUrl + '/DisablePaywayCustomer?customerNumber=' + customerNumber)
      .pipe(catchError(this.authService.handleError));
  }

  UpdateEBillingCustomerNo(customerNumber: string, tenantId: string, type: string): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(this.baseUrl + '/UpdateEBillingCustomerNo?customerNumber=' + customerNumber + '&tenantId=' + tenantId + '&type=' + type)
      .pipe(catchError(this.authService.handleError));
  }


  SetPaywayCustomer(formData: PaywayCustomerRequest): Observable<PaywayCustomerRequest> {
    return this.http.post<PaywayCustomerRequest>(this.baseUrl + '/SetPaywayCustomer', formData)
      .pipe(catchError(this.authService.handleError));
  }

  PaywayLanding(formData: PaywayCustomerRequest, singleUseTokenId: string): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(`${this.baseUrl}/PaywayLanding?singleUseTokenId=${singleUseTokenId}`, formData)
      .pipe(catchError(this.authService.handleError));
  }

  CartCheckout(cartId: number): Observable<CheckoutViewModel> {
    return this.http.get<CheckoutViewModel>(this.baseUrl + '/CartCheckout?cartId=' + cartId)
      .pipe(catchError(this.authService.handleError));
  }

  RemoveCartEndUser(cartId: number): Observable<any> {
    return this.http.get(this.baseUrl + '/RemoveCartEndUser?cartID=' + cartId)
      .pipe(catchError(this.authService.handleError));
  }

  GetAddressView(cartId: number): Observable<ShippingAddress> {
    return this.http.get<ShippingAddress>(this.baseUrl + '/GetAddressView?cartId=' + cartId)
      .pipe(catchError(this.authService.handleError));
  }

  GetEndUser(cartId: number, firstStep: string, kitProgramTypeList: string): Observable<EndUserModel> {
    return this.http.get<EndUserModel>(`${this.baseUrl}/GetEndUser?cartId=${cartId}&firstStep=${firstStep}&kitProgramTypeList=${kitProgramTypeList}`)
      .pipe(catchError(this.authService.handleError));
  }

  GetEndUserAddressSelectionView(salesType: string): Observable<GetEndUserSalesTypeOut[]> {
    return this.http.get<GetEndUserSalesTypeOut[]>(`${this.baseUrl}/GetEndUserAddressSelectionView?salesType=${salesType}`)
      .pipe(catchError(this.authService.handleError));
  }

  EndUserAddressBook(salesType: string): Observable<GetEndUserAddressBookOutput[]> {
    return this.http.get<GetEndUserAddressBookOutput[]>(`${this.baseUrl}/EndUserAddressBook?salesType=${salesType}`)
      .pipe(catchError(this.authService.handleError));
  }

  UpdateEndUserDetailAddress(data: string): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(`${this.baseUrl}/UpdateEndUserDetailAddress?data=${data}`)
      .pipe(catchError(this.authService.handleError));
  }

  SetEndUserDetail(data: string, cartId: number): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(`${this.baseUrl}/SetEndUserDetail?data=${data}&cartId=${cartId}`)
      .pipe(catchError(this.authService.handleError));
  }

  DeleteEndUserDetail(data: string): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(`${this.baseUrl}/DeleteEndUserDetail?data=${data}`)
      .pipe(catchError(this.authService.handleError));
  }

  GetCSPTenantView(programType: string, cartId: number): Observable<TenantViewModel> {
    return this.http.get<TenantViewModel>(`${this.baseUrl}/GetCSPTenantView?cartId=${cartId}&programType=${programType}`)
      .pipe(catchError(this.authService.handleError));
  }

  GetSubscriptionTenantView(programType: string, cartId: number): Observable<TenantViewModel> {
    return this.http.get<TenantViewModel>(`${this.baseUrl}/GetSubscriptionTenantView?cartId=${cartId}&programType=${programType}`)
      .pipe(catchError(this.authService.handleError));
  }

  GetCSPTenantListView(programType: string): Observable<GetCSPTenant[]> {
    return this.http.get<GetCSPTenant[]>(`${this.baseUrl}/GetCSPTenantListView?programType=${programType}`)
      .pipe(catchError(this.authService.handleError));
  }

  GetAutoDeskCSNList(programType: string): Observable<string[]> {
    return this.http.get<string[]>(`${this.baseUrl}/GetAutoDeskCSNList?programType=${programType}`)
      .pipe(catchError(this.authService.handleError));
  }

  CheckPrefix(prefix: string): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(`${this.baseUrl}/CheckPrefix?prefix=${prefix}`)
      .pipe(catchError(this.authService.handleError));
  }

  CreateCSPTenant(formCollection: string): Observable<TenantResponse> {
    return this.http.get<TenantResponse>(`${this.baseUrl}/CreateCSPTenant?formCollection=${formCollection}`)
      .pipe(catchError(this.authService.handleError));
  }

  CreateKASPTenant(formCollection: any): Observable<TenantResponse> {
    const formData = new FormData();
    formData.append('formCollection', formCollection);
    return this.http.post<TenantResponse>(this.baseUrl + '/CreateKASPTenant', formData)
      .pipe(catchError(this.authService.handleError));
  }

  CreateCirrusTenant(formCollection: any): Observable<CirrusTenantResponse> {
    const formData = new FormData();
    formData.append('formCollection', formCollection);
    return this.http.post<CirrusTenantResponse>(this.baseUrl + '/CreateCirrusTenant', formData)
      .pipe(catchError(this.authService.handleError));
  }

  CreateWGTenant(formCollection: string): Observable<TenantResponse> {
    return this.http.get<TenantResponse>(`${this.baseUrl}/CreateWGTenant?formCollection=${formCollection}`)
      .pipe(catchError(this.authService.handleError));
  }

  CreateAutoDeskTenant(formCollection: any): Observable<TenantResponse> {
    const formData = new FormData();
    formData.append('formCollection', formCollection);
    return this.http.post<TenantResponse>(this.baseUrl + '/CreateAutoDeskTenant', formData)
      .pipe(catchError(this.authService.handleError));
  }

  CreateADTenant(formCollection: string): Observable<TenantResponse> {

    return this.http.get<TenantResponse>(this.baseUrl + '/CreateADTenant?formCollection=' + formCollection)
      .pipe(catchError(this.authService.handleError));
  }

  AssociateCSPTenant(formCollection: string): Observable<TenantResponse> {
    return this.http.get<TenantResponse>(`${this.baseUrl}/AssociateCSPTenant?formCollection=${formCollection}`)
      .pipe(catchError(this.authService.handleError));
  }

  GetTenantIdByDomain(domain: string): Observable<TenantResponse> {
    return this.http.get<TenantResponse>(`${this.baseUrl}/GetTenantIdByDomain?domain=${domain}`)
      .pipe(catchError(this.authService.handleError));
  }

  SetTenantDetail(cartId: number, createCSPOrder: CreateCSPOrder[], programType: string): Observable<TenantResponse> {
    return this.http.post<TenantResponse>(`${this.baseUrl}/SetTenantDetail?cartId=${cartId}&programType=${programType}`, createCSPOrder)
      .pipe(catchError(this.authService.handleError));
  }

  ContinueToPayment(cartID: number, paymentType: string, poReference: string, customer_number: string, card_scheme: string, name_on_card: string): Observable<PaymentApiResponse> {
    return this.http.get<PaymentApiResponse>(this.baseUrl + '/ContinueToPayment?cartID=' + cartID
      + '&paymentType=' + paymentType
      + '&poReference=' + poReference
      + '&customer_number=' + customer_number
      + '&card_scheme=' + card_scheme
      + '&name_on_card=' + name_on_card)
      .pipe(catchError(this.authService.handleError));
  }

  GetSummaryView(cartId: number): Observable<CheckoutSummaryViewModel> {
    return this.http.get<CheckoutSummaryViewModel>(`${this.baseUrl}/GetSummaryView?cartId=${cartId}`)
      .pipe(catchError(this.authService.handleError));
  }

  PlaceOrder(cartId: number, paymentMethod: string): Observable<OrderConfirmationViewModel> {
    return this.http.get<OrderConfirmationViewModel>(`${this.baseUrl}/PlaceOrder?cartID=${cartId}&PAYMENTMETHOD=${paymentMethod}`)
      .pipe(catchError(this.authService.handleError));
  }

  OrderConfirmation(cartId: number, completedCartId: string): Observable<OrderConfirmationViewModel> {
    return this.http.get<OrderConfirmationViewModel>(`${this.baseUrl}/OrderConfirmation?cartID=${cartId}&completedCartId=${completedCartId}`)
      .pipe(catchError(this.authService.handleError));
  }

  AcceptTermsAndConditions(): Observable<CartResponse> {
    return this.http.get<CartResponse>(`${this.baseUrl}/AcceptTermsAndConditions`)
      .pipe(catchError(this.authService.handleError));
  }

  UpdateTermsandVersion(): Observable<string> {
    return this.http.get<string>(`${this.baseUrl}/UpdateTermsandVersion`)
      .pipe(catchError(this.authService.handleError));
  }

  UpsertDonation(cartId: number, donationValue?: number): Observable<boolean> {
    return this.http.get<boolean>(`${this.baseUrl}/UpsertDonation?cartID=${cartId}&donationValue=${donationValue}`)
      .pipe(catchError(this.authService.handleError));
  }

  GetDonationItem(cartId: number): Observable<CartItem> {
    return this.http.get<CartItem>(`${this.baseUrl}/GetDonationItem?cartID=${cartId}`)
      .pipe(catchError(this.authService.handleError));
  }

  GetTotalDonation(): Observable<string> {
    return this.http.get<string>(`${this.baseUrl}/GetTotalDonation`)
      .pipe(catchError(this.authService.handleError));
  }

  PrintToPDF(cartId: string): Observable<string> {
    return this.http.get<string>('/api/ExportExcel/PrintToPDF?completedCartId=' + cartId)
      .pipe(catchError(this.authService.handleError));
  }

  // Observable sources - check whether user has chosen to checkout and also which step are then in
  // tslint:disable-next-line:member-ordering
  private emitChangeSource = new Subject<CheckoutStatusModel>();
  // Observable streams
  // tslint:disable-next-line:member-ordering
  changeEmitted$ = this.emitChangeSource.asObservable();
  // Service message commands
  emitChange(change: any) {
    this.emitChangeSource.next(change);
  }

}
